import { AppKeys, newMsg } from '../../../core/localization';
import { LogVM } from '../../../models';
import { DownloadLog } from './model';
import { AreEqualILog, areEqualILog } from '../../historical';

export const msgHistoryHeader = newMsg(AppKeys.Download_History_Header);
export const msgLogNumDevices = (total: number) =>
  newMsg(AppKeys.Num_Device, [{ tag: 'count', value: total }]);
export const msgChecking = newMsg(AppKeys.DeviceLogs_Checking);
export const msgMoreLogsBtn = newMsg(AppKeys.DeviceLogs_LoadMore_Btn);
export const msgNoLogs = newMsg(AppKeys.Download_History_NoLogs);

export const areEqual: AreEqualILog<DownloadLog> = (a, b) =>
  areEqualILog(a, b) &&
  a.deviceCount === b.deviceCount &&
  a.username === b.username;

const getExecuter = (l: DownloadLog) => 
  `${l.username.startsWith('client_') ? 'M2M' : l.username}`;

export const mapLog = (l: DownloadLog): LogVM => ({
  date: new Date(l.datetime),
  title: msgLogNumDevices(l.deviceCount),
  subtitle: getExecuter(l),
});
